export enum DevicePlatform {
  AndroidTv = 'android-tv',
  Chromecast = 'chromecast',
  Chromebox = 'chromebox',
  Browser = 'browser',
  Unknown = 'unknown'
}
